import React, { useEffect, useState } from 'react'
import axios from 'axios';
const Archiv = () => {
    const[allDocuments,setAllDocuments]=useState([]);
      const documents = async () => {
    try {
      const response = await axios.post(
        "https://api.bbf-bike.de/api/documents/downloads",
        { data: "websites/viva/documents" },
      );
      setAllDocuments(response.data);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(()=>{
    window.scrollTo(0,0);
    documents();
  },[]);
    const catalogArray = allDocuments?.filter((item) =>
    item.toLowerCase().includes("katalog"),
  );
  return (
    <div className="min-h-screen h-auto flex justify-center items-center w-full">
      <div className="flex justify-space-between md:flex-row items-stretch w-full sm:flex-col-reverse">
        <div className="flex-1">
          <img
            src="https://media.bbf-bike.de/shop/documents/websites/viva/images/archiv.webp"
            alt="archiv_cover"
            className="object-cover h-full w-full"
          />
        </div>
        <div className="flex-1 bg-black text-white">
          <div className="md:pt-52 sm:pt-14 sm:px-5 md:pb-20 sm:pb-8 md:px-20 flex flex-col justify-start items-start gap-8">
             <div className="font-semibold uppercase mt-4 text-[18px]">
                      Kataloge
                    </div>
                         {catalogArray.reverse().map((cat, index) => (
                      <div key={index} className="w-full flex flex-col gap-1">
                        <a
                          href={`https://media.bbf-bike.de/shop/documents/bbf-bike/documents/${cat}`}
                          target="_blank">
                          {cat.replaceAll("-", " ").replace(".pdf", "")}
                        </a>
                        <div className="w-[60%] h-[2px] bg-white"></div>
                      </div>
                    ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Archiv